import { render } from "./Rotation.vue?vue&type=template&id=321fd842&scoped=true&ts=true"
import script from "./Rotation.vue?vue&type=script&lang=ts"
export * from "./Rotation.vue?vue&type=script&lang=ts"

import "./Rotation.vue?vue&type=style&index=0&id=321fd842&scoped=true&lang=less"

import exportComponent from "/Users/neal/Desktop/www/qingtv/qingtv-back-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321fd842"]])

export default __exports__